<template>
  <div class="d-flex align-items-center justify-content-between text-center h-100 p-5">
    <div>
      <img src="@/assets/error.svg" width="64" class="mb-3" alt="Error" />
      <h1>{{ message }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    message() {
      return this.$route.query.error || 'Oops! Something went wrong!'
    },
  },
}
</script>
